import React from 'react';
import { Cell, Pie, PieChart as RechartsPieChart } from 'recharts';

import { InnerContent } from './InnerContent';
import { ChartDataItem, PieChartProps } from './types';

export const PieChart: React.FC<Readonly<PieChartProps>> = ({
  data,
  width,
  height,
  innerRadius,
  outerRadius,
  startAngle,
  endAngle,
  className,
  centerPrimaryValue,
  centerSecondaryValue,
  stroke,
  isPrinting,
  responsive = true,
}) => {
  return (
    <div className={`${className}`} style={{ position: 'relative' }}>
      <RechartsPieChart
        responsive={responsive}
        style={{
          height,
          width,
        }}
      >
        <Pie
          data={data}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          stroke={stroke}
          dataKey="value"
        >
          {data.map((item: ChartDataItem, i: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <Cell key={`cell-${item.name}-${i}`} fill={item.fillColor} />
          ))}
        </Pie>
      </RechartsPieChart>
      <InnerContent
        primaryValue={centerPrimaryValue}
        secondaryValue={centerSecondaryValue}
        isPrinting={isPrinting}
      />
    </div>
  );
};
